import { useQuery } from '@tanstack/react-query';
import { getInitData } from 'services/apiAuth1';

const useInitialData = () => {
  return useQuery({
    queryKey: ['initialData'],
    queryFn: getInitData,
    staleTime: 60 * 60 * 1000,
  });
};

export default useInitialData;